import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const StyledProfileItemWrap = styled(Paper)({
	padding: '8px 16px',
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	overflow: 'hidden',
	borderRadius: '8px',
});

export const StyledProfileItemText = styled(Typography)({
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});
